import { render, staticRenderFns } from "./learnersBg.component.vue?vue&type=template&id=ac6f7eaa&scoped=true&"
import script from "./learnersBg.component.vue?vue&type=script&lang=js&"
export * from "./learnersBg.component.vue?vue&type=script&lang=js&"
import style0 from "./learnersBg.component.vue?vue&type=style&index=0&id=ac6f7eaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6f7eaa",
  null
  
)

export default component.exports